var hasClickedRitualButton = false;

function setupStandardRitual() {
    console.log("Setting up standard ritual.");
    setupRitual("main-character-list.txt").then(() => {
        ritualV2Progress();
    });
}

function setupLongRitual() {
    console.log("Setting up long ritual.");
    setupRitual("active-character-list.txt").then(() => {
        ritualV2Progress();
    });
}

function setupRitual(txtFileToLoad) {
    // ASSUMPTION: No characters have "," in their names. If they do, you're a jackass.
    console.log("Loading ritual file.");
    console.log("/assets/txt/" + txtFileToLoad);
    return loadTextFileToArray("/assets/txt/" + txtFileToLoad).then(characterNames => {
        console.log("Shuffling ritual file.");
        shuffle(characterNames);
        console.log("Putting names in local storage: " + characterNames.toString());
        localStorage.setItem("ritualCharacterList", characterNames.toString());
        localStorage.setItem("ritualCharactersGuessed", "0");
        localStorage.setItem("ritualCharactersTotal", characterNames.length.toString());
    });
}

function ritualV2Button() {
    if (!hasClickedRitualButton) {
        console.log("Ritual button not pressed, revealing.");
        hasClickedRitualButton = true;
        ritualV2Reveal();
    }
    else {
        console.log("Ritual button pressed, progressing.");
        ritualV2Progress();
    }
}

function ritualV2Reveal() {
    var nameTag = document.getElementById("ritual-v2-name");
    var powerTag = document.getElementById("ritual-v2-power");
    var buttonTag = document.getElementById("ritual-v2-button");
    var powerExplanationTag = document.createElement("p");

    nameTag.innerHTML = nameTag.getAttribute("data-character-name");
    powerTag.innerHTML = powerTag.getAttribute("data-power-name");
    powerExplanationTag.innerHTML = powerTag.getAttribute("data-power-explanation");
    buttonTag.innerHTML = "NEXT →";

    powerTag.parentElement.appendChild(powerExplanationTag);
}

function ritualV2Progress() {
    console.log("Loading next ritual page.");
    incrementRitualGuesses();
    var localStorageValue = localStorage.getItem("ritualCharacterList");
    console.log("ritualCharacterList is " + localStorageValue)
    if (localStorageValue) {
        var remainingCharacters = localStorageValue.split(",");
        console.log("More than one character remaining.");
        var nextCharacter = remainingCharacters.pop();
        localStorage.setItem("ritualCharacterList", remainingCharacters.toString());
        window.location.href = new URL("/ritual/" + nextCharacter, window.location.href).href;
    }
    else {
        console.log("Finished ritual!");
        localStorage.removeItem("ritualCharacterList");
        window.location.href = new URL("/ritual/complete", window.location.href).href;
    }
}

function getRitualCharactersRemaining() {
    var remainingCharacters = localStorage.getItem("ritualCharacterList").split(",");
    return remainingCharacters.length;
}

function incrementRitualGuesses() {
    localStorage.setItem("ritualCharactersGuessed", (Number(localStorage.getItem("ritualCharactersGuessed")) + 1).toString());
}

function getRitualCharactersGuessed() {
    return localStorage.getItem("ritualCharactersGuessed");
}

function getTotalRitualCharacters() {
    return localStorage.getItem("ritualCharactersTotal");
}

// Utils
function loadTextFileToArray(filePath) {
    return fetch(filePath)
        .then(response => response.text())
        .then(text => text.split('\n').map(line => line.trim()).filter(n => n))
        .catch(error => {
            console.error("Error loading the file:", error);
            return [];
        });
}

function shuffle(array) {
    console.log("Starting shuffle");
    let currentIndex = array.length;
    // While there remain elements to shuffle...
    while (currentIndex != 0) {
        // Pick a remaining element...
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
}

// Give window permission to use the relevant functions.
Object.assign(window, {
    setupStandardRitual,
    setupLongRitual,
    getRitualCharactersRemaining,
    getTotalRitualCharacters,
    getRitualCharactersGuessed,
    ritualV2Button
});